module.exports = __webpack_public_path__ + "img/Collectum.de5a9b84.png";